// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__2oigm","heading":"Container_heading__XxBvu","text":"Container_text__KFyvh"};